import { useTheme } from '@emotion/react';

export const usePalette = () => {
  const { palette } = useTheme();

  if (!palette) {
    throw new Error("Palette not found you probably didn't use ThemeProvider");
  }

  return palette;
};
